import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

const getOrganization = async () => {
  try {
    const response = await axios.get(`${API_URL}/dashboard/organization`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

// Without organizationId, edits the active organization.
const editOrganization = async ({ name, address }, { organizationId } = {}) => {
  try {
    const response = await axios.put(
      `${API_URL}/dashboard/organization`,
      { name, address },
      organizationId ? { headers: { 'X-Organization-Id': organizationId } } : undefined,
    );
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

const inviteMember = async (email) => {
  try {
    const response = await axios.post(`${API_URL}/dashboard/organization/members/invite`, { email });
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

const removeMember = async (userId) => {
  try {
    const response = await axios.delete(`${API_URL}/dashboard/organization/members/${userId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const changeRole = async (userId, role) => {
  try {
    const response = await axios.put(`${API_URL}/dashboard/organization/members/${userId}/role`, { role });
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

const leaveOrganization = async () => {
  try {
    const response = await axios.post(`${API_URL}/dashboard/organization/leave`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getOrganizations = async () => {
  try {
    const response = await axios.get(`${API_URL}/dashboard/organizations`, {
      skipOrganizationHeader: true,
    });
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

const api = {};
api.getOrganizations = getOrganizations;
api.getOrganization = getOrganization;
api.editOrganization = editOrganization;
api.addExistingMember = inviteMember;
api.inviteMember = inviteMember;
api.removeMember = removeMember;
api.changeRole = changeRole;
api.leaveOrganization = leaveOrganization;

export default api;
